// Catálogo completo de ítems del menú lateral.
// Cada ítem tiene: key (identificador único), section (agrupador), label (etiqueta visible).
// Este archivo es la fuente de verdad tanto para Layout (filtrado) como para RolesPage (checkboxes).

export const ALL_MENU_ITEMS = [
  // ── MAESTROS ────────────────────────────────────────────────────────
  { key: 'inicio',             section: 'MAESTROS',       label: 'Inicio' },
  { key: 'clientes',           section: 'MAESTROS',       label: 'Clientes' },
  { key: 'proveedores',        section: 'MAESTROS',       label: 'Proveedores' },
  { key: 'familia-productos',  section: 'MAESTROS',       label: 'Familia Productos' },
  { key: 'almacenes',          section: 'MAESTROS',       label: 'Almacenes' },
  { key: 'productos',          section: 'MAESTROS',       label: 'Productos' },
  // ── INVENTARIOS ─────────────────────────────────────────────────────
  { key: 'movimientos',        section: 'INVENTARIOS',    label: 'Movimientos' },
  { key: 'transferencias',     section: 'INVENTARIOS',    label: 'Transferencias' },
  { key: 'conversiones',       section: 'INVENTARIOS',    label: 'Conversiones' },
  { key: 'stocks',             section: 'INVENTARIOS',    label: 'Stocks' },
  // ── COMPRAS ─────────────────────────────────────────────────────────
  { key: 'compras',            section: 'COMPRAS',        label: 'Compras' },
  { key: 'cuentas-pagar',      section: 'COMPRAS',        label: 'Cuentas por Pagar' },
  // ── VENTAS ──────────────────────────────────────────────────────────
  { key: 'ventas',             section: 'VENTAS',         label: 'Ventas' },
  { key: 'cuentas-cobrar',     section: 'VENTAS',         label: 'Cuentas por Cobrar' },
  { key: 'cobranzas',          section: 'VENTAS',         label: 'Cobranzas' },
  { key: 'caja-apertura',      section: 'VENTAS/CAJA',    label: 'Apertura / Cierre' },
  { key: 'caja-historial',     section: 'VENTAS/CAJA',    label: 'Historial Cuadres' },
  // ── REPORTES ────────────────────────────────────────────────────────
  { key: 'rep-ventas-diarias',        section: 'REPORTES', label: 'Ventas Diarias' },
  { key: 'rep-utilidades',            section: 'REPORTES', label: 'Utilidades' },
  { key: 'rep-pedidos-urgentes',      section: 'REPORTES', label: 'Pedidos Urgentes' },
  { key: 'rep-seguimiento-productos', section: 'REPORTES', label: 'Seguimiento Productos' },
  // ── CONFIGURACION ───────────────────────────────────────────────────
  { key: 'config-unidades',          section: 'CONFIGURACION', label: 'Unidad de Medida' },
  { key: 'config-formas-pago',       section: 'CONFIGURACION', label: 'Forma Pago' },
  { key: 'config-tipos-documento',   section: 'CONFIGURACION', label: 'Tipo Documento' },
  { key: 'config-docs-pago',         section: 'CONFIGURACION', label: 'Documentos Pago' },
  { key: 'config-series-venta',      section: 'CONFIGURACION', label: 'Serie Venta' },
  { key: 'config-tipos-movimiento',  section: 'CONFIGURACION', label: 'Tipo Movimiento' },
  { key: 'config-whatsapp',          section: 'CONFIGURACION', label: 'WhatsApp' },
  // ── SEGURIDAD ───────────────────────────────────────────────────────
  { key: 'usuarios',           section: 'SEGURIDAD',      label: 'Usuarios' },
  { key: 'roles',              section: 'SEGURIDAD',      label: 'Roles' },
];

export const ALL_KEYS = ALL_MENU_ITEMS.map(i => i.key);

// Agrupado por section para uso en RolesPage
export const SECTIONS_ORDER = [
  'MAESTROS', 'INVENTARIOS', 'COMPRAS', 'VENTAS', 'VENTAS/CAJA',
  'REPORTES', 'CONFIGURACION', 'SEGURIDAD',
];

export const SECTION_LABELS = {
  'MAESTROS':       'Maestros',
  'INVENTARIOS':    'Almacenes',
  'COMPRAS':        'Compras',
  'VENTAS':         'Ventas',
  'VENTAS/CAJA':    'Ventas — Caja',
  'REPORTES':       'Reportes',
  'CONFIGURACION':  'Configuración',
  'SEGURIDAD':      'Seguridad',
};
